import { FC } from 'react';
import Link from 'next/link';
import Spacing from '../Spacing';
import Button from './Button';
import { EditButtonProps } from './button-props';
import { useAsyncClick } from '../hooks/useAsyncClick';
import { LoadingDots } from '../Loading';

const EditButton: FC<EditButtonProps> = ({
  target = '_blank',
  icon,
  title,
  onClick,
  onClickAsync,
  url,
  enabled = true,
  isWorking = false,
  preventDoubleClick = true,
}: EditButtonProps) => {
  const { run, isRunning } = useAsyncClick(
    async (e?: any) => {
      if (onClickAsync) await onClickAsync(e);
      else if (onClick) await Promise.resolve(onClick(e));
    },
    { debounceMs: 500 }
  );
  const working = isWorking || (preventDoubleClick && isRunning);
  const canClick = enabled && !working;
  const handleClick = (e) => (onClickAsync ? run(e) : onClick && onClick(e));

  const content = (
    <Button
      border="1px solid #E9EAF3"
      hasHover={true}
      radius="full"
      color={canClick ? 'black' : 'disabled'}
      size="xs"
      text={canClick}
      fullWidth={false}
      center={false}
      shadow={false}
      onClick={url ? undefined : handleClick}
      style={{ position: icon ? 'relative' : 'inherit' }}
      disabled={!canClick}
    >
      {icon && (
        <div
          style={{
            position: 'absolute',
            left: '6px',
            top: '6px',
            height: '32px',
            aspectRatio: '1',
            borderRadius: '100%',
            background: 'white',
            overflow: 'hidden',
          }}
        >
          {icon}
        </div>
      )}
      {icon && <Spacing left="md" />}
      {working ? <LoadingDots color="black" /> : title}
    </Button>
  );

  if (url) {
    return (
      <Link href={url}>
        <a target={target} style={{ textDecoration: 'none' }}>
          {content}
        </a>
      </Link>
    );
  }

  return content;
};

export default EditButton;
